export interface ItemPreset {
    name: string;
    icon: string;
    items: string[];
}

export class ItemPresets {
    static readonly BLUMEN: ItemPreset = {
        name: 'BLUMEN',
        icon: 'fa-solid fa-fan',
        items: [
            'minecraft:red_flower',
            'minecraft:red_flower:1', //blaue Orchidee
            'minecraft:red_flower:2', //Sternlauch
            'minecraft:red_flower:3', //Porzerllansternchen
            'minecraft:red_flower:4', //rote Tulpe
            'minecraft:red_flower:5', //orange Tulpe
            'minecraft:red_flower:6', //weiße Tulpe
            'minecraft:red_flower:7', //rosa Tulpe
            'minecraft:red_flower:8', //Magerite
        ]
    };

    static readonly BRUCHSTEIN_SPAWNER: ItemPreset = {
        name: 'BRUCHSTEIN_SPAWNER',
        icon: 'fa-solid fa-cube',
        items: [
            'minecraft:cobblestone',
            'minecraft:gold_ingot',
            'minecraft:diamond',
            'minecraft:dirt',
            'minecraft:dye:4', // Lapis Lazuli (dye with metadata 4)
            'minecraft:emerald',
            'minecraft:iron_ingot',
            'minecraft:coal',
            'minecraft:stone',
            'minecraft:redstone',
			'minecraft:diamond_ore',
			'minecraft:iron_ore',
			'minecraft:gold_ore',
			'minecraft:coal_ore',
			'minecraft:redstone_ore',
			'minecraft:emerald_ore',			
        ]
    };
	
	static readonly WAECHTER_SPAWNER: ItemPreset = {
        name: 'WAECHTER_SPAWNER',
        icon: 'fa-solid fa-cube',
        items: [
            'minecraft:prismarine_crystals',
            'minecraft:prismarine_shard',
        ]
    };
	static readonly HEXE_SPAWNER: ItemPreset = {
        name: 'HEXE_SPAWNER',
        icon: 'fa-solid fa-cube',
        items: [
            'minecraft:stick',
            'minecraft:glowstone_dust',
			'minecraft:sugar',
			'minecraft:redstone',
			'minecraft:gunpowder',
			'minecraft:spider_eye',
        ]
    };
	static readonly CREEPER_SPAWNER: ItemPreset = {
        name: 'CREEPER_SPAWNER',
        icon: 'fa-solid fa-cube',
        items: [
			'minecraft:gunpowder',
        ]
	};
	static readonly TINTENFISCH_SPAWNER: ItemPreset = {
        name: 'TINTENFISCH_SPAWNER',
        icon: 'fa-solid fa-cube',
        items: [
			'minecraft:dye',
        ]
	};
	
	static readonly LOHEN_SPAWNER: ItemPreset = {
        name: 'LOHEN_SPAWNER',
        icon: 'fa-solid fa-cube',
        items: [
			'minecraft:blaze_rod',
        ]
	};
	
    static readonly WOOD_LOGS: ItemPreset = {
        name: 'WOOD_LOGS',
        icon: 'fa-solid fa-tree',
        items: [
            'minecraft:log:0', // Oak Log
            'minecraft:log:1', // Spruce Log  
            'minecraft:log:2', // Birch Log
            'minecraft:log:3', // Jungle Log
            'minecraft:log2:0', // Acacia Log
            'minecraft:log2:1'  // Dark Oak Log
        ]
    };

    static readonly ANIMAL_PRODUCTS: ItemPreset = {
        name: 'ANIMAL_PRODUCTS',
        icon: 'fa-solid fa-cow',
        items: [
            'minecraft:beef',
            'minecraft:porkchop',
            'minecraft:chicken',
            'minecraft:mutton',
            'minecraft:rabbit',
            'minecraft:leather',
            'minecraft:wool',
            'minecraft:feather',
            'minecraft:egg',
            'minecraft:milk_bucket'
        ]
    };

    static readonly ALL_PRESETS = [
        ItemPresets.BRUCHSTEIN_SPAWNER,
        ItemPresets.WOOD_LOGS,
        ItemPresets.ANIMAL_PRODUCTS,
        ItemPresets.BLUMEN,
        ItemPresets.CREEPER_SPAWNER,
        ItemPresets.TINTENFISCH_SPAWNER,
        ItemPresets.LOHEN_SPAWNER,
        ItemPresets.HEXE_SPAWNER,
        ItemPresets.WAECHTER_SPAWNER
    ];

    static getPresetByName(name: string): ItemPreset | undefined {
        return ItemPresets.ALL_PRESETS.find(preset => preset.name === name);
    }
}